import { sentryLogException } from "@/utils/sentry";

export const SHOE_PRICE_CACHE_TTL = 5 * 60 * 1000;
const SHOE_PRICE_CACHE_STORAGE_KEY = "shoePriceCache";

const getCacheFromStorage = () => {
	try {
		const cached = localStorage.getItem(SHOE_PRICE_CACHE_STORAGE_KEY);
		if (cached) {
			return JSON.parse(cached);
		}
	} catch (e) {
		sentryLogException("Shoe Price Cache Read", e);
	}
	return {};
};

const saveCacheToStorage = (cache) => {
	try {
		localStorage.setItem(SHOE_PRICE_CACHE_STORAGE_KEY, JSON.stringify(cache));
	} catch (e) {
		sentryLogException("Shoe Price Cache Write", e);
	}
};

export const getCachedPrice = (cacheKey) => {
	const cache = getCacheFromStorage();
	const cached = cache[cacheKey];
	const now = Date.now();

	if (cached && now - cached.timestamp < SHOE_PRICE_CACHE_TTL) {
		return {
			success: cached.success,
			data: cached.data,
			error: cached.error,
		};
	}

	if (cached) {
		delete cache[cacheKey];
		saveCacheToStorage(cache);
	}

	return null;
};

export const setCachedPrice = (cacheKey, data) => {
	const cache = getCacheFromStorage();
	cache[cacheKey] = {
		success: true,
		data,
		error: null,
		timestamp: Date.now(),
	};
	saveCacheToStorage(cache);
};

export const setCachedError = (cacheKey, error) => {
	const cache = getCacheFromStorage();
	cache[cacheKey] = {
		success: false,
		data: null,
		error: error || "Something went wrong",
		timestamp: Date.now(),
	};
	saveCacheToStorage(cache);
};

